
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { UserTable } from "@/components/users/UserTable";
import { DeleteUserDialog } from "@/components/users/DeleteUserDialog";
import { useUsers } from "@/hooks/useUsers";
import { useEffect } from "react";
import { StatusFilter } from "@/components/users/table/StatusFilter";

const Users = () => {
  const {
    users,
    loading,
    userToDelete,
    setUserToDelete,
    handleDelete,
    fetchUsers,
    searchQuery,
    handleSearchChange,
    page,
    pageSize,
    totalCount,
    handlePageChange,
    statusFilter,
    handleStatusFilterChange,
  } = useUsers();

  // Add cleanup for ResizeObserver warning
  useEffect(() => {
    const reportError = (event: ErrorEvent) => {
      if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
        event.stopImmediatePropagation();
      }
    };

    window.addEventListener('error', reportError);
    return () => window.removeEventListener('error', reportError);
  }, []);

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12">
              <div>
                <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                  Users
                </h1>
                <p className="text-xl text-gray-600 mt-2">
                  Manage accounts and permissions
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6">
              <UserTable
                users={users}
                loading={loading}
                onDelete={setUserToDelete}
                onUserUpdated={fetchUsers}
                searchQuery={searchQuery}
                onSearchChange={handleSearchChange}
                page={page}
                pageSize={pageSize}
                totalCount={totalCount}
                onPageChange={handlePageChange}
                statusFilter={statusFilter}
                onStatusFilterChange={handleStatusFilterChange}
              />
            </div>
          </div>
        </div>
      </div>

      <DeleteUserDialog
        user={userToDelete}
        isOpen={!!userToDelete}
        onClose={() => setUserToDelete(null)}
        onConfirm={() => userToDelete && handleDelete(userToDelete)}
      />
    </SidebarProvider>
  );
};

export default Users;
